






































































































































































































import { computed, defineComponent, reactive, ref, toRefs, watch } from '@vue/composition-api';
import dayjs from 'dayjs';
import searchCreatorPopup from '@/renderer/views/desktop/FileManagement/Search/components/searchCreator.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { SearchParam } from '@/renderer/views/desktop/FileManagement/Search/composition/searchHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { formatSize } from '@/renderer/scripts/utils/tools';
import ipc from '@/renderer/scripts/utils/ipc';

function formatSizeString(itemSize?: string) {
  const { size, unit } = formatSize(itemSize as string);
  return `${size}${unit}`;
}

/**
 * 带条件选择的搜索
 */
export default defineComponent({
  name: 'SearchConditionSelect',
  components: {
    searchCreatorPopup,
  },
  props: {
    spaceId: {
      type: String,
      default: '',
    },
    searchParams: {
      type: Object as () => SearchParam,
      default: {
        keyword: '',
        keywordCache: '',
        scope: 'all',
        scopeCache: 'all',
        types: ['all'],
        typesCache: ['all'],
        rangeCache: 'fileName',
        timeCache: 'all',
        sizeCache: 'all',
        member: ['all'],
        memberCache: ['all'],
        members: '',
        originMember: [],
      },
    },
    searchCondition: {
      type: Object,
      default: {
        modificationTimeStart: '',
        modificationTimeEnd: '',
        creators: [],
      },
    },
    SearchRangeOptions: {
      type: Array,
    },
    SearchTypeOptions: {
      type: Array,
    },
    SearchTimeOptions: {
      type: Array,
    },
    SearchSizeOptions: {
      type: Array,
    },
    SearchMemberOptions: {
      type: Array,
    },
  },
  setup(props) {
    const { searchParams, searchCondition } = toRefs(props);
    const { sizeMap } = ConstantConfig;
    const memberNameArr = ref([]);
    const sizePopupVisible = ref(false);
    const timePopupVisible = ref(false);
    const beforeMonthDate = dayjs().subtract(30, 'days').format('YYYY-MM-DD');
    const disabledDate = dayjs().format('YYYY-MM-DD');
    const dateRangeParams = ref([beforeMonthDate, disabledDate]);
    const show = reactive({
      timePopup: false,
      sizePopup: false,
      memberPopup: false,
    });
    const isShowSizeSelect = computed(
      () => searchParams.value.types.length === 1 && searchParams.value.types[0] === 'dir',
    );
    const sizeOptions = Object.keys(ConstantConfig.sizeMap).map(key => ({
      label: key,
      value: key,
    }));
    const headRange = reactive({
      size: '',
      unit: 'MB',
    });
    const endRange = reactive({
      size: '',
      unit: 'MB',
    });
    const minFileSize = computed(() => Number(headRange.size) * sizeMap[headRange.unit]);
    const maxFileSize = computed(() => Number(endRange.size) * sizeMap[endRange.unit]);
    // 可输入的最大限制1000GB
    const limitFileSize = 1000 * sizeMap.GB;
    const isEmpty = computed(() => headRange.size === '' || endRange.size === '');
    const isBeyondLimit = computed(() => minFileSize.value > limitFileSize || maxFileSize.value > limitFileSize);
    const isBeyondRange = computed(() => minFileSize.value > maxFileSize.value);
    const methods = {
      // 点击"内容"select框，弹窗消失
      driverDismiss() {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_SEARCH_GUIDE);
      },
      onSelectTypes(val: string[]) {
        if (val.includes('all') || (val.includes('file') && val.includes('dir'))) {
          searchParams.value.types = ['all'];
        }
      },
      onSelectTimeRange(val: string) {
        switch (val) {
          case '0': {
            const startTime = dayjs().format('YYYY-MM-DD 00:00:00');
            const endTime = dayjs().format('YYYY-MM-DD 23:59:59');
            searchCondition.value.modificationTimeStart = dayjs(startTime).format();
            searchCondition.value.modificationTimeEnd = dayjs(endTime).format();
            break;
          }
          case '7':
          case '30':
          case '365':
            searchCondition.value.modificationTimeStart = dayjs()
              .subtract(Number(searchParams.value.time), 'days')
              .format('YYYY-MM-DD');
            searchCondition.value.modificationTimeEnd = dayjs().format('YYYY-MM-DD 23:59:59');
            break;
          default:
            searchCondition.value.modificationTimeStart = '';
            searchCondition.value.modificationTimeEnd = '';
            break;
        }
      },
      timePopupChange(visible: boolean) {
        timePopupVisible.value = visible;
        show.sizePopup = false;
        show.memberPopup = false;
      },
      showCustomizeTime() {
        timePopupVisible.value = false;
        show.timePopup = true;
        dateRangeParams.value = [beforeMonthDate, disabledDate];
      },
      onTimePickchange(context: { date: Date[]; e: MouseEvent }) {
        const { date } = context;
        dateRangeParams.value[0] = dayjs(date[0]).format('YYYY-MM-DD');
        dateRangeParams.value[1] = dayjs(date[1]).format('YYYY-MM-DD');
      },
      onSubmitTime() {
        const firstTime = dateRangeParams.value[0];
        const secondTime = dateRangeParams.value[1];
        const startTime = Date.parse(secondTime) - Date.parse(firstTime) > 0 ? firstTime : secondTime;
        const endTime = Date.parse(secondTime) - Date.parse(firstTime) > 0 ? secondTime : firstTime;
        if (firstTime === secondTime) {
          const startTimeFormat = dayjs(startTime).format('YYYY-MM-DD 00:00:00');
          const endTimeFormat = dayjs(startTime).format('YYYY-MM-DD 23:59:59');
          searchCondition.value.modificationTimeStart = dayjs(startTimeFormat).format();
          searchCondition.value.modificationTimeEnd = dayjs(endTimeFormat).format();
          searchParams.value.time = `${startTime}`;
        } else {
          searchCondition.value.modificationTimeStart = startTime;
          // 若只传日期不传时间，后端默认是00:00:00
          searchCondition.value.modificationTimeEnd = dayjs(endTime).format('YYYY-MM-DD 23:59:59');
          searchParams.value.time = i18n_t('{startTime}至{endTime}', {
            startTime,
            endTime,
          });
        }
        show.timePopup = false;
      },
      onSelectSizeRange(val: string) {
        switch (val) {
          case '0-1MB':
          case '1-5MB':
          case '5-25MB':
          case '25-100MB':
            searchCondition.value.minFileSize = Number(val.split('-')[0]) * sizeMap.MB;
            searchCondition.value.maxFileSize = Number(val.split('-')[1].split('M')[0]) * sizeMap.MB;
            break;
          case '100MB-1GB':
            searchCondition.value.minFileSize = 100 * sizeMap.MB;
            searchCondition.value.maxFileSize = 1 * sizeMap.GB;
            break;
          case '1GB+': {
            searchCondition.value.minFileSize = 1 * sizeMap.GB;
            break;
          }
          default:
            break;
        }
      },
      sizePopupChange(visible: boolean) {
        sizePopupVisible.value = visible;
      },
      showCustomizeSize() {
        methods.resetSize();
        sizePopupVisible.value = false;
        show.sizePopup = true;
      },
      resetSize() {
        headRange.size = '';
        headRange.unit = 'MB';
        endRange.size = '';
        endRange.unit = 'MB';
      },
      onSubmitSize() {
        show.sizePopup = false;
        searchParams.value.size = `${formatSizeString(minFileSize.value.toString())}-${formatSizeString(
          maxFileSize.value.toString(),
        )}`;
        searchCondition.value.minFileSize = minFileSize.value;
        searchCondition.value.maxFileSize = maxFileSize.value;
      },
      onClickMember() {
        show.memberPopup = true;
      },
      onSubmitMember(params: any, memberTotal: number, hideSearchMember: boolean) {
        show.memberPopup = false;
        searchParams.value.originMember = params;
        if (params.length !== 0 && (params.length !== memberTotal || hideSearchMember)) {
          memberNameArr.value = params.map((item: any) => item.nickname);
          searchParams.value.members = memberNameArr.value.join(',');
          searchCondition.value.creators = params.map((item: any) => ({
            userOrgId: item.userOrgId,
            userId: item.userId,
          }));
          searchParams.value.member = memberNameArr.value;
        } else {
          searchParams.value.member = ['all'];
          searchCondition.value.creators = [];
        }
      },
      onSelectMembers(val: []) {
        if (val.length !== 0) {
          searchParams.value.members = val.join(',');
        }
        searchParams.value.originMember.shift();
        searchCondition.value.creators.shift();
      },
      onTimeClickOutside() {
        show.timePopup = false;
      },
      onSizeClickOutside() {
        show.sizePopup = false;
      },
      onMemberClickOutside() {
        setTimeout(() => {
          show.memberPopup = false;
        }, 0);
      },
      initData() {
        methods.onSelectTypes(['all']);
      },
    };
    // 自定义文件大小 size检验
    watch(
      () => [headRange.size, endRange.size],
      val => {
        headRange.size = `${val[0]}`.replace(/\D/g, '');
        endRange.size = `${val[1]}`.replace(/\D/g, '');
      },
    );
    return {
      sizeOptions,
      show,
      headRange,
      endRange,
      isEmpty,
      isBeyondLimit,
      isBeyondRange,
      sizePopupVisible,
      timePopupVisible,
      disabledDate,
      dateRangeParams,
      isShowSizeSelect,
      ...methods,
    };
  },
});
